
const SERVICE_TYPE_MANAGE_LIST = 'SERVICE_TYPE_MANAGE_LIST';
const SERVICE_TYPE_MANAGE_PAGE = 'SERVICE_TYPE_MANAGE_PAGE';
const SERVICE_TYPE_MANAGE_CONDITION = 'SERVICE_TYPE_MANAGE_CONDITION';
const SERVICE_TYPE_MANAGE_ADD_CONDITION = 'SERVICE_TYPE_MANAGE_ADD_CONDITION';

const ServiceTypeModel = function () {
  const name = 'ServiceType';
  return {
    name,
    state: {
      list: [],
      condition: {
        name: '',
        mchNo:'',
      },
      addCondition:{
        id:'',
        name:'',
        price:'',
        mchNo:'',
        remark:'',
      },
      page: {
        cur_page: 1,
        size: 30,
        total: 0
      }
    },
    selectors: (state) => {
      const currentState = state[name];
      const selectors = {
        getList: () => currentState.list,
        getPage: () => currentState.page,
        getCondition: () => currentState.condition,
        getAddCondition: () => currentState.addCondition,
      };
      return selectors;
    },
    actions: {
      changeList: (list) => (dispatch, getState) => {
        dispatch({
          type: SERVICE_TYPE_MANAGE_LIST,
          list
        });
      },
      changePage: (page) => (dispatch, getState) => {
        dispatch({
          type: SERVICE_TYPE_MANAGE_PAGE,
          page
        });
      },
      changeCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: SERVICE_TYPE_MANAGE_CONDITION,
          key,
          value
        });
      },
      changeAddCondition: (key, value) => (dispatch, getState) => {
        dispatch({
          type: SERVICE_TYPE_MANAGE_ADD_CONDITION,
          key,
          value
        });
      },
    },
    reducers: {
      list: (state = ServiceTypeModel.state.list, action) => {
        if (action.type === SERVICE_TYPE_MANAGE_LIST) {
          return [...action.list];
        }
        return state;
      },
      page: (state = ServiceTypeModel.state.page, action) => {
        if (action.type === SERVICE_TYPE_MANAGE_PAGE) {
          return Object.assign({}, state, action.page);
        }
        return state;
      },
      condition: (state = ServiceTypeModel.state.condition, action) => {
        if (action.type === SERVICE_TYPE_MANAGE_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      },
      addCondition: (state = ServiceTypeModel.state.addCondition, action) => {
        if (action.type === SERVICE_TYPE_MANAGE_ADD_CONDITION) {
          const { key, value } = action;
          let obj = {};
          obj[key] = value;
          return Object.assign({}, state, obj);
        }
        return state;
      }
    }
  };
}();

export default ServiceTypeModel;


// WEBPACK FOOTER //
// ./src/models/ServiceTypeMamageModel.js